import { create } from 'zustand';

export const useLeadUIStore = create((set) => ({
	// Modal states
	showEmailListModal: false,
	setShowEmailListModal: (val) => set({ showEmailListModal: val }),

	detailLeadId: null,
	setDetailLeadId: (val) => set({ detailLeadId: val }),

	// Compound actions
	handleShowLeadDetails: (leadId) => set({ detailLeadId: leadId }),

	handleHideLeadDetails: () => set({ detailLeadId: null }),
}));
